
export class OrderInfoForNavigation {
    orderNumber?: string;
    webOrderNumber?: string;
    source?: string;
    distrubutorId?:string;
    name?:string;
    country?:string;
    memberType?:string;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/order-info-navigate.ts